// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseList from "../../../../../engines/components/BaseList";
import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import gameConfig from "../../../../../engines/configs/gameConfig";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { MansionKind } from "../../../../define/MansionKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import MansionsBuildItem from "./MansionsMemberItem";

const {ccclass, property} = cc._decorator;


enum BtnType {
    ALL = 1,
    WIFE,
    CHILD,
    UNOPEN,
}
@ccclass
export default class MansionsMemberLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelAllCosts: cc.Label = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    @property(cc.Node)
    nodeBtnList: cc.Node = null;

    @property(cc.Label)
    labelAllPeople: cc.Label = null;

    private itemArray: string[][] = [];

    private curType = BtnType.ALL;

    // private csvInfos = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        // this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.WIFE);
        // if (!this.csvInfos) {
        //     console.error(`未找到表格数据`);
        //     return;
        // }

        O1HD.on(MessageEventKind.EventName.REFRESH_MAINSION_MEMBER_DATA, this.refreshMemberDayData, this);
        this.refreshMemberDayData();
        this.initLayer();
    }

    initLayer() {
        this.refreshState();
    }

    refreshState() {

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        
        let wifeCount = wifeDataManage.ownWifeCount();
        let childCount = childDataManage.ownChildCount();

        let allCount = wifeCount + childCount;
        let children = this.nodeBtnList.children;
        let type = BtnType.ALL;
        let labelNum = children[type-1].getChildByName('labelNum')?.getComponent(cc.Label);
        labelNum && (labelNum.string = (allCount) + '人');

        type = BtnType.WIFE;
        labelNum = children[type-1].getChildByName('labelNum')?.getComponent(cc.Label);
        labelNum && (labelNum.string = (wifeCount) + '人');

        type = BtnType.CHILD;
        labelNum = children[type-1].getChildByName('labelNum')?.getComponent(cc.Label);
        labelNum && (labelNum.string = (childCount) + '人');

        this.labelAllPeople.string = (allCount) + '/' + mansionData.curCapacity;

        this.labelAllPeople.node.color = allCount <= mansionData.curCapacity ? cc.color(0x75, 0xC7, 0x65) : cc.color(0xff, 0x00, 0x00);
        // cc.color(0xc6, 0x65, 0x65);
        this.refreshCosts();
        this.refreshBtnState();
        this.initScroll();
    }

    refreshCosts() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let costGold = mansionData.costGold * 10000;
        this.labelAllCosts.string = data_control.getNumberFormat(costGold);
    }

    initScroll() {
        let content = this.scrollView.content;
        content.removeAllChildren();
        this.itemArray = [];

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeData = mansionDataManage.wifeDataManage.wifeData;
        let childData = mansionDataManage.childDataManage.childData;
        

        let bWife = this.curType == BtnType.WIFE || this.curType == BtnType.ALL;
        let bChild = this.curType == BtnType.CHILD || this.curType == BtnType.ALL;

        if (bWife) {
            wifeData.lists.forEach((v, key)=> {
                if (v.state == MansionKind.WifeState.WIFE && v.bEnterMansion) {
                    let itemD = [BtnType.WIFE + '', key];
                    if (v.bNew) {
                        this.itemArray.unshift(itemD)    
                    } else {
                        this.itemArray.push(itemD);
                    }
                }
            });
        }

        let sIdx = this.itemArray.length;
        if (bChild) {
            childData.lists.forEach((v, key)=> {
                if (!v.bEnterMansion) {
                    return;
                }

                let itemD = [BtnType.CHILD + '', key];
                if (v.bNew) {
                    this.itemArray.splice(sIdx, 0, itemD);
                } else {
                    this.itemArray.push(itemD);
                }
            });
        }

        let list = this.scrollView.getComponent(BaseList);
        list.numItems = this.itemArray.length;
    }

    refreshBtnState() {

        let children = this.nodeBtnList.children;

        children.forEach((v, i)=> {
            let btn = v.getComponent(cc.Button);
            let stateSprite = btn.getComponent(BaseStateSprite);
            if (i == (this.curType-1)) {
                stateSprite.setFill(true);
                btn.interactable = false;
            } else {
                stateSprite.setFill(false);
                btn.interactable = true;
            }
        });
        
    }

    renderItem(scroll: BaseList, item, idx: number) {
        let array = this.itemArray;
        let data = array[idx];

        let key = data[1];
        let bWife = false;

        if (data[0] == BtnType.WIFE + '') {
            bWife = true;
        }

        let itemScript: MansionsBuildItem = item.getComponent(MansionsBuildItem);
        itemScript.setData(
            this
            , bWife
            , key
        );
    }

    async refreshHint() {
        let gameData = NormalGameManager._instance.getGameData();
        if (!gameData.bBuyMansion) {
            return;   
        }
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        
        let wifeCount = wifeDataManage.ownWifeCount();
        let childCount = childDataManage.ownChildCount();
        
        if ((wifeCount + childCount) > mansionData.curCapacity) {
            
            await new Promise<void>(resolve => {
                let data = {
                    id: "38"
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        resolve();
                    }
                }

                utilsView.openEventLayer(
                    null
                    , data
                    , UI_Z_INDEX.DIALOG
                );
            });

            
        }
    }

    async refreshMemberDayData() {
        await this.refreshHint();
        
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeData = mansionDataManage.wifeDataManage.wifeData;
        let curDay = NormalGameManager._instance.getCurrentDay();
        let self = this;
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.WIFE);
        if (!csvInfos) {
            console.error(`未找到表格数据`);
            return;
        }
        let title = csvInfos.title;

        let gameData = NormalGameManager._instance.getGameData();
        let bSave = false;
        let bTotalGirlCount = false;
        let array = Array.from(wifeData.lists.keys());
        for (let i = 0; i < array.length; i++) {
            let key = array[i];
            let v = wifeData.lists.get(key);
            // v.bFetation = true;
            if (v.state == MansionKind.WifeState.WIFE && v.bEnterMansion && v.bFetation && curDay > v.lastServantDate) {
                let info = csvInfos[key];
                if (!info) {
                    console.error(`未找到数据 WIFE key = ` + key);
                    return;
                }
                v.bFetation = false;
                bSave = true;
                let cData = mansionDataManage.createChild(key);
                mansionDataManage.mansionDataDispose();

                let strDesc = `恭喜老爷, ${info[title.real_name]}夫人给府中喜添一位` + (cData.bBoy ? '公子' : '千金');

                if (!cData.bBoy) {
                    bTotalGirlCount = true;
                }

                await new Promise<void>(resolve => {
                    utilsView.openPopupLayerTwo(
                        FileKind.PrefabFilePath.EnterLayerEventShow2
                        , null
                        , {
                            parent: this
                            , peopleName: '管家'
                            , peopleIcon: '波斯使者'
                            , btnName: '确定'
                            , addPeoplePos: cc.v2(0, 90)
                            , nodeHeight: 280
                            , sprBg: ''
                            , descList: [
                                ['', strDesc]
                            ]
                            , exitCb: ()=> {
                                self.refreshState();
                                resolve();
                            }
                        }
                    );
                });
            }
        }

        
        if (!gameData.bGrilAwardSui && bTotalGirlCount) {
            let grilCount = 0;
            mansionDataManage.childDataManage.childData.lists.forEach((v)=> {
                if (!v.bBoy) {
                    grilCount++;
                }
            });

            if (grilCount >= gameConfig.GRIL_COUNT_AWARD_SUI) {
                NormalGameManager._instance.setGameData({bGrilAwardSui: true});
                let data = {
                    id: "43"
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                }
                utilsView.openEventLayer(
                    null
                    , data
                    , UI_Z_INDEX.DIALOG
                );
            }
        }

        if (bSave) {
            wifeData.saveLocalData();
            this.refreshState();
        }
    }

    onClickBtn(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (data == BtnType.UNOPEN) {
            O1HD.getModules().uiControlModule.showMessageBox('暂未开放');
            return;
        }
        this.curType = Number(data);
        this.refreshBtnState();
        this.initScroll();
    }

    onClickHelp() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsView.openPopupLayer(
            'prefab/member/MansionsMemberHint'
            , BUNDLE_SMALL_NAME.mansionBundle
        );
    }

    onClickBuild() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
        utilsView.openPopupLayer(
            'prefab/build/MansionsBuildLayer'
            , BUNDLE_SMALL_NAME.mansionBundle
        );
    }
    
    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
